/**
 * @generated SignedSource<<e83873f0337ca76df2e9aee3b0464410>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkChangeAccessForSavedReportInput = {
  ids?: ReadonlyArray<string | null> | null;
  privateAccess?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type bulkChangeAccessForSavedReportMutation$variables = {
  input: BulkChangeAccessForSavedReportInput;
};
export type bulkChangeAccessForSavedReportMutation$data = {
  readonly bulkChangeAccessForSavedReport: {
    readonly savedReports: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly privateAccess: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type bulkChangeAccessForSavedReportMutation = {
  variables: bulkChangeAccessForSavedReportMutation$variables;
  response: bulkChangeAccessForSavedReportMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkChangeAccessForSavedReportPayload",
    "kind": "LinkedField",
    "name": "bulkChangeAccessForSavedReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SavedReportTypeConnection",
        "kind": "LinkedField",
        "name": "savedReports",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SavedReportTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SavedReportType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "privateAccess",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkChangeAccessForSavedReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkChangeAccessForSavedReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "71d481b1c2c76f9b82d7b5e5ecaea652",
    "id": null,
    "metadata": {},
    "name": "bulkChangeAccessForSavedReportMutation",
    "operationKind": "mutation",
    "text": "mutation bulkChangeAccessForSavedReportMutation(\n  $input: BulkChangeAccessForSavedReportInput!\n) {\n  bulkChangeAccessForSavedReport(input: $input) {\n    savedReports {\n      edges {\n        node {\n          id\n          privateAccess\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a9ef9a24046815c093d76d192f85a45";

export default node;
